import React, { FC } from 'react'

import {
  TrackingPageTypeWithId,
  TrackingPageTypeWithoutId,
  TrackingRecoSectionContext,
} from '@aboutyou/legacy-tracking-sdk'
import { RecoSliderSectionTrackingContextProvider } from 'helpers/tracking/SectionTrackingContext'
import OutfitTileConnected from 'sharedComponents/ProductStream/OutfitTileConnected'
import styled, { css } from 'styled-components'
import RowSection from 'uiComponents/atoms/Sections/RowSection'
import HorizontalSlider from 'uiComponents/molecules/Slider/HorizontalSlider'

const DividerSection = styled(RowSection)<{ constrained?: boolean }>`
  ${({ constrained }) =>
    constrained
      ? null
      : css`
          margin-bottom: 120px;
        `};
`

interface IProductRecoSliderProps {
  outfitIds: string[]
  recoType: TrackingRecoSectionContext['recoType']
  slideCounts: {
    slideCount: number
    slideCountMedium: number
    slideCountLarge: number
  }
  dataTestId?: string
  title?: React.ReactNode
  headerContent?: React.ReactNode
  pullStart?: boolean
  pullEnd?: boolean
  constrained?: boolean
  trackingRecoTitle?: string
  maxNumOutfits?: number
  onClick?: VoidFunction
  pageType: TrackingPageTypeWithId | TrackingPageTypeWithoutId
}

const OutfitRecoSlider: FC<IProductRecoSliderProps> = ({
  outfitIds,
  slideCounts,
  constrained,
  pullStart,
  pullEnd,
  title,
  headerContent,
  maxNumOutfits = 12,
  dataTestId = 'OutfitRecoSlider',
  onClick,
  pageType,
}) => {
  if (outfitIds.length < 3) {
    return null
  }

  return (
    <DividerSection
      data-testid={dataTestId}
      pullStart={pullStart}
      pullEnd={pullEnd}
      constrained={constrained}
    >
      <HorizontalSlider
        dataTestId="HorizontalSlider"
        title={title}
        as="div"
        disableHeaderControl
        constrained={constrained}
        {...slideCounts}
        headerContent={headerContent}
      >
        {outfitIds.slice(0, maxNumOutfits).map(id => (
          <OutfitTileConnected
            key={id}
            outfitId={id}
            disableContent
            onClick={onClick}
            pageType={pageType}
          />
        ))}
      </HorizontalSlider>
    </DividerSection>
  )
}

const TrackedOutfitRecoSlider: FC<IProductRecoSliderProps> = props => (
  <RecoSliderSectionTrackingContextProvider
    headline={props.trackingRecoTitle}
    recoType={props.recoType}
  >
    <OutfitRecoSlider {...props} />
  </RecoSliderSectionTrackingContextProvider>
)

export default TrackedOutfitRecoSlider
